import * as React from 'react'

function FailIcon(props) {
  const color = props.isDark ? '#696969' : '#00a9e3'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={43} height={43} {...props}>
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M21.5,1.5c11,0,20,9,20,20s-9,20-20,20
	s-20-9-20-20S10.5,1.5,21.5,1.5z M30.5,11.3L12.5,31.7 M31.7,30.5L11.3,12.5"
      />
    </svg>
  )
}

export default FailIcon
